import { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, TextField, DialogContentText, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

export default function PaymentReport() {
    const navigate = useNavigate();
    const handleNavigateToPaymentReport = () => {
        navigate('/payment-report');
    }
    const handleNavigateToPaymentReportPaid = () => {
        navigate('/payment-report-paid');
    }
    const handleNavigateToPaymentReportUnpaid = () => {
        navigate('/payment-report-unpaid');
    }
    const handleNavigateToPaymentReportDaily = () => {
        navigate('/payment-report-daily');
    }
    const [searchTerm, setSearchTerm] = useState();
    const [selectedOption, setSelectedOption] = useState();
    const [listingDataLoading, setListingDataLoading] = useState(false); 
    const [listingData, setListingData] = useState([]);  
    const [idToDelete, setIdToDelete] = useState(null);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);    

    const [selectedDate, setSelectedDate] = useState(null);
    const [dialogData, setDialogData] = useState({ title: "", action: "", id: null });
    const [showDialog, setShowDialog] = useState(false);  
    const [showErrorDialog, setShowErrorDialog] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    let [allPage, setAllPage] = useState(1);

    const [formData, setFormData] = useState({
        id: "",
        amount: "",
        payment_method: "",
    });
    // Alert message
    const [alertVisible, setAlertVisible] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertSeverity, setAlertSeverity] = useState('success');

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]:  value, 
        }));
    };

    // ========================>> Action buttons

    const renderActionButton = (id) => {
        return (
            <div className="render-action-buttons flex">
                <button onClick={() => {handleEditListing(id)}} className="flex bg-blue-700 rounded-xl py-1 pl-2 pr-1 lg:px-3 text-white text-sm justify-center items-center mr-3">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-4 mr-1">
                        <path strokeLinecap="round" strokeLinejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125" />
                    </svg>
                    <span className="hidden lg:flex">Edit</span>
                </button>
                <button onClick={() => {handleDeleteListing(id)}} className="flex bg-red-700 rounded-xl py-1 pl-2 pr-1 lg:px-3 text-white text-sm justify-center items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-4 mr-1">
                        <path strokeLinecap="round" strokeLinejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
                    </svg>
                    <span className="hidden lg:flex">Delete</span>
                </button>
            </div>
        )
    }

    const handleEditListing = (data) => {
        setFormData({
            id: data.id,
            amount: data.amount,
            payment_method: data.payment_method.method_name,
        });
        setDialogData({ title: "កែប្រែទិន្នន័យ", action: "edit", data });
        setShowDialog(true);
    }

    const handleDeleteListing = (idToDelete) => {
        setIdToDelete(idToDelete.id);
        setDeleteDialogOpen(true); // Open the confirmation dialog
    };

    const confirmDelete = async () => {
        setDeleteDialogOpen(false); // Close the dialog
        if (!idToDelete) return;

        try {
            const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/payment/${idToDelete}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                throw new Error("ទិន្នន័យបរាជ័យក្នុងការលុប"); 
            }

            // Show success alert
            setAlertMessage("ទិន្នន័យត្រូវបានលុបដោយជោគជ័យ");
            setAlertSeverity("success");
            setAlertVisible(true);

            setTimeout(() => {
                setAlertVisible(false);
            }, 1000);
            fetchView();
        } catch (error) {
            console.error(error.message);
            setAlertMessage(error.message);
            setAlertSeverity("error");
            setAlertVisible(true);
        }
    };


    const toggleSelectedOption = async (option) => {
        setSelectedOption(true);
    }

    const handleSearchSubmit = async (event) => {
        event.preventDefault(); 
        fetchSearch(searchTerm); 
    }; 

    const fetchSearch = async (searchTerm) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/payment/search?search=${searchTerm}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'Content-Type': 'application/json'
                }
            });
    
            if (!response.ok) {
                throw new Error('Failed to fetch search');
            }
    
            const data = await response.json(); 
            setListingData(data); 
        } catch (error) {
            console.error('Error fetching search:', error);
        }
    };

    const fetchView = async (page, date = null) => {
        setListingDataLoading(true);

        try {
            let url = `${process.env.REACT_APP_API_ENDPOINT}/payment/all?page=${page}&limit=30`;
            if (date) {
                url += `&date=${date}`;
            }

            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Failed to fetch data.');
            }

            const dataExpense = await response.json();
            setListingData(dataExpense);
        } catch (err) {
            console.error(err.message);
        } finally {
            setListingDataLoading(false);
        }
    };

    useEffect(() => {
    }, [listingData]); 

    useEffect(() => {
        fetchView(allPage, selectedDate?.toISOString().split('T')[0]);  
    }, [allPage]);
    
    const handleDateChange = (date) => {
        setSelectedDate(date);
        if (date) {
            // Create date object in Phnom Penh timezone (UTC+7)
            const phnomPenhDate = new Date(date.toLocaleString('en-US', { timeZone: 'Asia/Phnom_Penh' }));
            const year = phnomPenhDate.getFullYear();
            const month = String(phnomPenhDate.getMonth() + 1).padStart(2, '0');
            const day = String(phnomPenhDate.getDate()).padStart(2, '0');
            const formattedDate = `${year}-${month}-${day}`;
            fetchView(allPage, formattedDate);
        } else {
            fetchView(allPage, null);
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        if (!formData.amount) {
            setErrorMessage("សូមបញ្ចូលចំនួនទឹកប្រាក់");
            setShowErrorDialog(true);
            return;
        }

        if (!formData.payment_method) {
            setErrorMessage("សូមបញ្ចូលប្រភេទបង់ប្រាក់");
            setShowErrorDialog(true);
            return;
        }

        fetch(`${process.env.REACT_APP_API_ENDPOINT}/payment/${formData.id}`, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        })
        .then((response) => {
            if (!response.ok) {
                return response.json().then((data) => {
                    setAlertMessage(data.message);
                    setAlertSeverity("error");
                    setAlertVisible(true);
                    setTimeout(() => {
                        setAlertVisible(false);
                    }, 2000);
                    throw data;
                })
            }
            return response.json();
        })
        .then(() => {
            fetchView(allPage);
            setShowDialog(false);
            setAlertMessage(`ទិន្នន័យត្រូវបានធ្វើបច្ចុប្បន្នភាពដោយជោគជ័យ`);
            setAlertSeverity("success");    
            setAlertVisible(true);
            setTimeout(() => {
                setAlertVisible(false);
            }, 2000);
        })
        .catch((error) => {
            setAlertMessage(error.message);
            setAlertMessage(`ទិន្នន័យត្រូវបានធ្វើបច្ចុប្បន្នភាពបរាជ័យ`);
            setAlertSeverity("error");
            setAlertVisible(true);
            setTimeout(() => {
                setAlertVisible(false);
            }, 2000)
        })
    };

    return (
        <div className="w-full h-[100dvh] bg-white flex flex-col">
            {/* Header */}
            <div className="w-full h-[8dvh] bg-[#0077B6] flex  items-center">
                <div className="md:w-[8%] pl-3 md:pl-10 items-center flex text-customWhite">
                    <NavLink to='/'>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-12 text-white">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 15.75 3 12m0 0 3.75-3.75M3 12h18" />
                        </svg>
                    </NavLink>
                </div>
                <div className="w-[84%] flex justify-center">
                    <h2 className="text-2xl font-semibold text-customWhite">បញ្ជីបង់ប្រាក់</h2>
                </div>
            </div>

            {/* Done Header */}

            {/* Body */}
            <div className="w-full">
                {/* Action button */}
                <div className="flex flex-col md:flex-row w-full items-center border-b">
                    <div className="grid grid-cols-4 w-full md:w-[40%] h-[9dvh] text-xl mr-8">
                        <button className="hover:bg-slate-200 border-b-2 border-primary2" onClick={handleNavigateToPaymentReport}>ទាំងអស់</button>
                        <button className="hover:bg-slate-200" onClick={handleNavigateToPaymentReportPaid}>បានបង់ប្រាក់</button>
                        <button className="hover:bg-slate-200" onClick={handleNavigateToPaymentReportUnpaid}>មិនទាន់បង់</button>
                        <button className="hover:bg-slate-200" onClick={handleNavigateToPaymentReportDaily}>បញ្ជីប្រចាំថ្ងៃ</button>
                    </div>
                    <div className="flex px-5 lg:px-0 w-full md:w-[40%] items-center py-2 ml-auto">
                        <form onSubmit={handleSearchSubmit} className="w-[100%]">
                            <div className="search-box !w-[95%] !shadow-none !border-2 !rounded-2xl">
                                <FontAwesomeIcon icon={faSearch} className="search-icon" />
                                <input
                                    type="text"
                                    placeholder="Search"
                                    className="ml-4 font-inter"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)} 
                                />
                            </div>
                        </form>
                    </div>
                </div>

                {/* Table */}
                {listingDataLoading && listingData.data ? (
                    <div className="text-center my-10">
                        <p>Loading data...</p>
                    </div>
                    ) : (
                        <div className="overflow-x-auto overflow-y-auto !h-[76vh]">
                            <table className="table-display w-[100%]">
                                <thead className="!bg-secondary3 border-2">
                                    <tr>
                                        {/* <th className="rounded-tl-lg text-zinc-800  text-xs md:text-sm lg:!text-base">បន្ទប់</th> */}
                                        <th className="text-zinc-800  text-xs md:text-sm lg:!text-base !py-4 ml-3">បន្ទប់</th>
                                        <th className="text-zinc-800  text-xs md:text-sm lg:!text-base !py-4">ឈ្មោះ</th>
                                        <th className=" text-zinc-800  text-xs md:text-sm lg:!text-base !py-4">លេខទូរស័ព្ទ</th>
                                        <th className=" text-zinc-800  text-xs md:text-sm lg:!text-base !py-4">តម្លៃបានបង់</th>
                                        <th className=" text-zinc-800 text-xs md:text-sm  lg:!text-base !py-4">កាលបរិច្ឆេទបង់ប្រាក់</th>
                                        <th className=" text-zinc-800 text-xs md:text-sm  lg:!text-base !py-4">វិធីបង់ប្រាក់</th>   
                                        <th className="text-zinc-800 text-xs md:text-sm lg:!text-base !py-4">កែសម្រួល</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {listingData && listingData.data ? (
                                        
                                        listingData.data.map((listing, index) => (
                                            <tr key={index} className="even:bg-gray-100 hover:bg-gray-200">
                                                <td className=" text-xs md:text-sm lg:!text-base !py-4 ml-3">{listing.room.room_number || '--'}</td>
                                                <td className="font-medium text-xs md:text-sm lg:!text-base !py-4">{listing.room.tenant || '--'}</td>
                                                <td className="font-medium text-gray-600 text-xs md:text-sm lg:!text-base !py-4">
                                                    {listing.tenant_phone_number 
                                                        ? listing.tenant_phone_number.replace(/(\d{3})(\d{3})(\d{3,4})/, '$1 $2 $3') 
                                                        : '--'}
                                                </td>
                                                <td className="font-medium text-xs md:text-sm lg:!text-base !py-4">
                                                    {listing.amount !== undefined && listing.amount !== null 
                                                        ? Number(listing.amount).toLocaleString('en-US')
                                                        : '--'}{listing.currency === 'USD' ? '$' : '៛'}
                                                </td>
                                                <td className="font-medium text-xs md:text-sm lg:!text-base !py-4">
                                                    {listing.created_at
                                                        ? (() => {
                                                            const date = new Date(listing.created_at);
                                                            const hours = date.getHours();
                                                            const minutes = date.getMinutes().toString().padStart(2, '0');
                                                            const ampm = hours >= 12 ? 'PM' : 'AM';
                                                            const formattedTime = `${hours % 12 || 12}:${minutes} ${ampm}`;
                                                            const day = date.getDate().toString().padStart(2, '0');
                                                            const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Month is 0-indexed
                                                            const year = date.getFullYear();
                                                            return `${formattedTime} ${day}-${month}-${year}`;
                                                        })()
                                                        : '--'}
                                                </td>
                                                <td className="font-medium text-xs md:text-sm lg:!text-base !py-4">
                                                    <div className={`active-status-chip ${listing.payment_method.method_name === 'cash' ? 'text-green-900 !bg-green-200' : 'text-yellow-900 !bg-yellow-200'}`}>{listing.payment_method.method_name  || '--'}</div>
                                                </td>
                                                <td className="w-[15%]">{renderActionButton(listing)}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="7">No records found for the selected month and year.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            {!selectedDate ?
                            <div className="fixed bottom-0 left-0 right-0 bg-gray-100 shadow-md border-t border-gray-300 flex justify-center items-center py-1">
                                
                                <button
                                    className="text-5xl px-5"
                                    onClick={() => setAllPage(prev => prev - 1)}
                                    disabled={allPage <= 1}
                                    style={{ opacity: allPage <= 1 ? 0.5 : 1, cursor: allPage < 2 ? "not-allowed" : "pointer" }}
                                >
                                    ←
                                </button>
                                <div className="text-2xl mx-10">{allPage}</div>
                                <button
                                    className="text-5xl px-5"
                                    onClick={() => setAllPage(prev => prev + 1)}
                                    disabled={!listingData.data || listingData.data.length === 0}
                                    style={{ 
                                        opacity: !listingData.data || listingData.data.length === 0 ? 0.5 : 1, 
                                        cursor: !listingData.data || listingData.data.length === 0 ? "not-allowed" : "pointer" 
                                    }}
                                >
                                    →
                                </button>
                            </div> :
                            <div className="fixed bottom-0 left-0 right-0 bg-gray-100 shadow-md border-t border-gray-300 flex justify-center items-center py-1">
                                {listingData && (
                                    <div className="my-2 flex gap4 items-center space-x-5">
                                        <div className="flex items-center space-x-2">
                                            <p className="text-base text-gray-600">សរុប</p>
                                            <p className="text-xl font-bold">{listingData.total} បន្ទប់</p>
                                        </div>
                                        <div className="flex items-center space-x-2">
                                            <p className="text-base text-gray-600">សរុប USD</p>
                                            <p className="text-xl font-bold">${listingData.total_amount_USD?.toLocaleString()}</p>
                                        </div>
                                        <div className="flex items-center space-x-2">
                                            <p className="text-base text-gray-600">សរុប KHR</p>
                                            <p className="text-xl font-bold">៛{listingData.total_amount_KHR?.toLocaleString()}</p>
                                        </div>
                                    </div>
                                )}
                            </div>}
                                
                        </div>
                        
                    )
                }
                {alertVisible && (
                    <Stack sx={{ width: '100%', justifyContent: "flex-end", position: "fixed",
                        alignItems: "flex-end"}}  mt={-5} spacing={2} borderRadius={2}>
                        <Alert severity={alertSeverity} sx={{fontWeight: 500, fontSize: '16px'}}>
                            {alertMessage}
                        </Alert>
                    </Stack>
                )}          
            </div>
            
            {/* Dialog for Add/Edit */}
            <Dialog open={showDialog} onClose={() => setShowDialog(false)} sx={{
                '& .MuiDialogTitle-root, & .MuiDialogContent-root, & .MuiDialogActions-root': {
                    fontFamily: 'Kantumruy Pro, sans-serif'
                }
            }}>
                <DialogTitle>{dialogData.title}</DialogTitle>
                <DialogContent>
                    <form onSubmit={handleSubmit}>
                        <TextField
                        margin="dense"
                        label="ចំនួនទឹកប្រាក់ *"
                        name="amount"
                        value={formData.amount !== null ? formData.amount : ''}
                        onChange={handleInputChange}
                        fullWidth
                        InputLabelProps={{
                            style: { fontFamily: 'Kantumruy Pro' },
                        }}
                        InputProps={{
                            style: {
                                borderRadius: "8px",
                                fontFamily: 'Kantumruy Pro',
                            }
                        }}
                        />
                        <FormControl
                        fullWidth
                        margin="dense"
                        sx={{
                            '& .MuiInputLabel-root': {
                            fontFamily: 'Kantumruy Pro',
                            },
                            '& .MuiSelect-select': {
                            borderRadius: "8px",
                            fontFamily: 'Kantumruy Pro',
                            },
                        }}
                        >
                            <InputLabel>បង់ប្រាក់តាមរយៈ *</InputLabel>
                            <Select
                                name="payment_method"
                                value={formData.payment_method || ""}
                                onChange={handleInputChange}
                                label="បង់ប្រាក់តាមរយៈ *"
                            >
                                <MenuItem value="cash" sx={{fontFamily: 'Kantumruy Pro'}}>សាច់ប្រាក់</MenuItem>
                                <MenuItem value="acleda" sx={{fontFamily: 'Kantumruy Pro'}}>អេស៊ីលីដា</MenuItem>
                            </Select>
                        </FormControl>
                    </form>
                </DialogContent>
                <DialogActions sx={{marginBottom: "16px"}}>
                <Button onClick={() => setShowDialog(false)} color="black"  
                sx={{paddingY: "8px", paddingX: "32px", marginRight: "16px",'&:hover': {
                    backgroundColor: '#f9f9f9',
                }, }}>
                    Cancel
                </Button>
                <Button onClick={handleSubmit} sx={{background: "#00B4D8", color: "white", paddingY: "8px", paddingX: "32px", marginRight: "16px" }}>
                    Save
                </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={showErrorDialog} onClose={() => setShowErrorDialog(false)} sx={{
                '& .MuiDialogTitle-root, & .MuiDialogContent-root, & .MuiDialogActions-root': {
                    fontFamily: 'Kantumruy Pro, sans-serif',
                }
            }}>
                <DialogTitle sx={{color: "red"}}>Error</DialogTitle>
                <DialogContent>
                    <div style={{ whiteSpace: 'pre-line' }}>
                        {errorMessage}
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setShowErrorDialog(false)} color="secondary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
                <DialogTitle sx={{ fontFamily: 'Kantumruy Pro'}}>បញ្ជាក់ការលុបបន្ទប់</DialogTitle>
                <DialogContent>
                    <DialogContentText sx={{ fontFamily: 'Kantumruy Pro'}}>
                        តើអ្នកពិតជាចង់់លុបបន្ទប់នេះមែនទេ?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDeleteDialogOpen(false)} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={confirmDelete} color="primary">
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
                 
        </div>
    )
}